import React, { FC, useEffect } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DateInput, SwitchInput, TextInput } from "@/components/atoms";

import { CustomerCardFormType } from "../../../../../formType";

const DriverLicense: FC = () => {
    const { control, watch, setValue } = useFormContext<CustomerCardFormType>();
    const { t } = useTranslation();
    const hasDriversLicense = watch("driverLicense.hasDriverLicense");

    useEffect(() => {
        if (!hasDriversLicense) {
            setValue("driverLicense.idNumber", "");
            setValue("driverLicense.validUntil", null);
        }
    }, [hasDriversLicense]);

    return (
        <>
            <SwitchInput
                name="driverLicense.hasDriverLicense"
                control={control}
                label={t("CustomerDetails.DriverLicense.Label")}
            />
            {hasDriversLicense && (
                <>
                    <TextInput
                        name="driverLicense.idNumber"
                        label={t("Common.Number")}
                        autoComplete="off"
                        control={control}
                    />
                    <DateInput
                        name="driverLicense.validUntil"
                        control={control}
                        label={t("CustomerDetails.DriverLicense.ValidUntil")}
                    />
                </>
            )}
        </>
    );
};

export default DriverLicense;
